import { render } from "./TrayectoriaES.vue?vue&type=template&id=b0c86230&scoped=true"
import script from "./TrayectoriaES.vue?vue&type=script&lang=js"
export * from "./TrayectoriaES.vue?vue&type=script&lang=js"

import "./TrayectoriaES.vue?vue&type=style&index=0&id=b0c86230&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0c86230"]])

export default __exports__